import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PETITION_DETAILS_PAGE_SPIKING_PETITION_BANNER_EXPERIMENT = defineFcm(
	'petition_details_page_spiking_petition_banner_experiment',
)
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string', optional: true },
				petitionId: { type: 'number', optional: true },
				signatureCountOverride: {
					type: 'number',
					optional: true,
					normalizer: (value: number) => {
						if (!Number.isInteger(value) || value < 0) {
							throw new Error('signatureCountOverride must be a non-negative integer');
						}
						return value;
					},
				},
				petitionTitleOverride: { type: 'string', optional: true },
				timeRangeOverride: { type: 'string', optional: true },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'petition details page (en-US only: set the values in the en-US locale only)',
		description: `Gates the spiking petition banner experiment, shown below the header on petition pages, except on the spiking petition itself and on pages where an emergency or starter-dashboard banner already shows (those take priority).
			- experimentName: experiment service name (dynamic so ops can swap iterations without a deploy). Required to enable.
			- petitionId: integer ID of the spiking petition the banner links to. Required to enable.
			- signatureCountOverride: optional non-negative integer. Replaces the live count of signatures in the past 24 hours. Any other number makes the whole FCM invalid, so the experiment is disabled.
			- petitionTitleOverride: optional string. Replaces the spiking petition's title.
			- timeRangeOverride: optional string (English, not translated). Replaces "the past 24 hours".
			Banner text defaults to "<n> people signed <petition title> in the past 24 hours".
			With overrides it reads "<signatureCountOverride> people signed <petitionTitleOverride> in <timeRangeOverride>".
			Overrides apply only to v1.`,
		template: {
			experimentName: 'petition_details_page_spiking_petition_banner_experiment',
			petitionId: 123456,
		},
	});
